import React from "react";
import Balance from "../components/Balance";
import Form from "../components/Form";
import Transactions from "./../components/Transactions";

const Home = () => {
  return (
    <div className='homepage-wrapper'>
      <Balance />
      <Form />
      <Transactions />
    </div>
  );
};

export default Home;
